/* Sweepstakes sign up, shared by the pop up and the footer form.
   When a Klaviyo company ID and list ID are set (Theme settings > Yumama), the email joins that list
   through Klaviyo's public client API, with the journey stage as a profile property. When they are
   not set, enabled() is false and the caller lets its normal Shopify customer form submit instead,
   tagged, so no email is ever lost. The company ID is public by design; nothing secret is here. */
(function () {
  var cfg = window.YumamaSubscribeConfig || {};
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function enabled() {
    return !!(cfg.companyId && cfg.listId);
  }

  function valid(email) {
    return EMAIL.test(String(email || '').trim());
  }

  function klaviyo(email, properties, source) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'Website',
          profile: { data: { type: 'profile', attributes: { email: String(email).trim(), properties: properties || {} } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      // Klaviyo answers 202 Accepted with an empty body on success
      if (res.status === 202 || res.ok) return { ok: true };
      return { ok: false, status: res.status };
    }, function () {
      return { ok: false, status: 0 };
    });
  }

  window.YumamaSubscribe = { enabled: enabled, valid: valid, klaviyo: klaviyo };
})();
